'use client';

import { useEffect, useLayoutEffect, useRef, useSyncExternalStore } from 'react';
import { hayEditorFormato, registrarEditorFormato, suscribirEditorFormato, type ContextoEditor } from './asistente-formato';
import type { FormatTemplateInput } from './types';

/**
 * El formulario de Formatos ABIERTO se registra para el asistente; cerrado
 * (la lista, Cancelar, Volver, el atrás del navegador) o desmontado (otra
 * pantalla), no queda registro. Con refs, el registro dura lo que dura la
 * plantilla abierta y no se rehace en cada render.
 */
export function useRegistroAsistenteFormato(
  open: boolean,
  clave: string | undefined,
  v: FormatTemplateInput,
  setV: (v: FormatTemplateInput) => void,
  contexto: ContextoEditor,
): void {
  const vRef = useRef(v);
  const setRef = useRef(setV);
  const contextoRef = useRef(contexto);
  useLayoutEffect(() => {
    vRef.current = v;
    setRef.current = setV;
    contextoRef.current = contexto;
  });
  useEffect(() => {
    if (!open) return;
    return registrarEditorFormato({
      obtener: () => vRef.current,
      poner: (nuevo) => { vRef.current = nuevo; setRef.current(nuevo); },
      contexto: () => contextoRef.current,
    });
  }, [open, clave]);
}

/** ¿Hay un editor de Formatos abierto? Para el saludo y las sugerencias del panel. */
export const useHayEditorFormato = (): boolean => useSyncExternalStore(suscribirEditorFormato, hayEditorFormato, () => false);
